import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Modal from '../../containers/modal';

import {
  createClubOfferOnboarding,
  getOrganizationList
} from '../../burger-king-lib/redux/offers/actions';
import Button from '../../components/button';
import LocationRestriction from '../../components/location-restriction-popover';
import { getLeftArrowImage } from '../../utils/imageChanges';
import TermsAndConditions from './components/onboarding-terms';
import './index.scss';

const OfferOnboarding = props => {
  const theme = 'takeaway';
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const initialDetails = [
    { key: 'name', label: 'Name', value: '', isMandatory: true },
    {
      key: 'contactNumber',
      label: 'Contact Number',
      value: '',
      isMandatory: true
    },
    { key: 'city', label: 'City', value: '', isMandatory: true }
  ];

  const initialUserInfo = Object.fromEntries(
    initialDetails.map(detail => [detail.key, detail.value])
  );

  const [userinfo, setUserInfo] = useState(initialUserInfo);
  const [organizationList, setOrganizationList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({
    name: '',
    organizationName: '',
    contactNumber: '',
    city: '',
    showSuccessModal: false,
    showErrorModal: false,
    errorMessage: ''
  });

  const [validationErrors123, setValidationErrors123] = useState({
    name: '',
    organizationName: '',
    contactNumber: '',
    city: '',
    showSuccessModal: false,
    showErrorModal: false,
    errorMessage: ''
  });

  const urlParams = new URLSearchParams(location.search);

  const organizationIdFromUrl = urlParams.get('organization_id');

  useEffect(() => {
    const meta = {
      callBack: successCallBack
    };

    if (organizationIdFromUrl) {
      dispatch(getOrganizationList('', meta));
    } else {
      history.push('/');
      // dispatch(getOrganizationList('', meta));
    }
  }, [organizationIdFromUrl, location.pathname, dispatch]);

  useEffect(() => {
    if (organizationIdFromUrl && organizationList.length > 0) {
      const selectedOrg = organizationList.find(
        org => org.organization_id === organizationIdFromUrl
      );
      if (selectedOrg) {
        setUserInfo({
          ...userinfo,
          organizationName: selectedOrg
        });
      }
    }
  }, [organizationIdFromUrl, organizationList]);

  const successCallBack = response => {
    let tempData = response?.content?.map(item => ({
      value: item.organization_name,
      label: item.organization_name,
      organization_id: item.organization_id
    }));

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    // const baseUrl = 'http://localhost:3000';
    // console.log('base', baseUrl);

    let organizationDataWithUrls = response?.content?.map(item => {
      const queryParams = new URLSearchParams({
        organization_id: item.organization_id
      });
      const urlWithParams = `${baseUrl}/offer-onboarding?${queryParams.toString()}`;

      // console.log(
      //   `Generated URL for ${item.organization_name}: ${urlWithParams}`
      // );

      return {
        display_name: item?.display_name,
        id: item?.id,
        organization_id: item?.organization_id,
        organization_name: item?.organization_name,
        url: urlWithParams
      };
    });

    // console.log('All Generated URLs:', organizationDataWithUrls);

    if (
      organizationIdFromUrl &&
      !tempData.some(org => org.organization_id === organizationIdFromUrl)
    ) {
      setValidationErrors123({
        ...validationErrors,
        showErrorModal: true,
        errorMessage: 'Organization not available.'
      });

      return;
    }

    setOrganizationList(tempData);
  };

  const validateForm = () => {
    const errors = {};
    setValidationErrors({});

    if (!userinfo.name.trim()) {
      errors.name = 'Name is required.';
    } else {
      const nameRegex = /^[A-Za-z\s]+$/;
      if (!nameRegex.test(userinfo.name)) {
        errors.name = 'Name should contain only alphabets.';
      }
    }

    const contactNumberRegex = /^\d{10}$/;
    if (!userinfo.contactNumber.trim()) {
      errors.contactNumber = 'Contact number is required.';
    } else if (!contactNumberRegex.test(userinfo.contactNumber)) {
      errors.contactNumber = 'Contact number should contain only digits.';
    } else if (userinfo.contactNumber.length !== 10) {
      errors.contactNumber = 'Contact number should be a 10-digit number.';
    }

    if (!userinfo.city.trim()) {
      errors.city = 'City is required.';
    }

    if (!userinfo.organizationName?.value) {
      errors.organizationName = 'Organization is required.';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onCreateSuccessCallBack = response => {
    if (response?.error === 0) {
      setValidationErrors({ ...validationErrors, showSuccessModal: true });
    } else if (response?.error === 1) {
      setValidationErrors({
        ...validationErrors,
        showErrorModal: true,
        errorMessage: response?.message
      });
    }
  };

  const handlePlaceHolder = detail => {
    return detail?.isMandatory ? `${detail?.label} *` : `${detail?.label}`;
  };

  const handleSubmit = async () => {
    const isValid = validateForm();

    if (isValid) {
      const payload = {
        name: userinfo.name,
        phone_no: userinfo.contactNumber,
        organization_name: userinfo.organizationName?.value,
        city: userinfo.city,
        email: null,
        job_title: null,
        workAddress: null,
        dob: null,
        gender: null,
        state: null
      };
      const meta = {
        formType: 'clubOffer',
        callBack: onCreateSuccessCallBack
      };
      dispatch(createClubOfferOnboarding(payload, meta));
    }
  };

  const downloadClicked = () => {
    window.open('https://burgerkingindia.page.link/gNpB');
  };

  return (
    <Modal
      onCloseHandler={props?.closeMe}
      hideClose
      modalCustomClass={'custom-modal'}
    >
      <div className="feedback-form_header">
        <div className="closeBtn">
          <div>
            <img
              onClick={props?.closeMe}
              src={getLeftArrowImage()}
              alt="back buttn"
              className="butn"
            />
          </div>
          <div className="feedback-form__title">KINGS CLUB OFFER</div>
          <div />
        </div>
      </div>
      {!validationErrors.showSuccessModal ? (
        <div className="onboarding-container">
          <div className="form-container">
            <div key="name">
              <input
                className={`inputStyles ${
                  validationErrors.name ? 'error' : ''
                }`}
                placeholder={handlePlaceHolder(initialDetails[0])}
                name={initialDetails[0].key}
                value={userinfo.name}
                onChange={e =>
                  setUserInfo({ ...userinfo, name: e.target.value })
                }
              />
              {validationErrors.name && (
                <span className="error-message">{validationErrors.name}</span>
              )}
            </div>
            <div key="contactNumber">
              <input
                className={`inputStyles ${
                  validationErrors.contactNumber ? 'error' : ''
                }`}
                placeholder={handlePlaceHolder(initialDetails[1])}
                name={initialDetails[1].key}
                value={userinfo.contactNumber}
                onChange={e => {
                  if (initialDetails[1].key === 'contactNumber') {
                    if (e.target.value.length <= 10) {
                      setUserInfo({
                        ...userinfo,
                        contactNumber: e.target.value
                      });
                    }
                  } else {
                    setUserInfo({
                      ...userinfo,
                      [initialDetails[1].key]: e.target.value
                    });
                  }
                }}
              />
              {validationErrors.contactNumber && (
                <span className="error-message">
                  {validationErrors.contactNumber}
                </span>
              )}
            </div>
            <div key="organizationName">
              <Select
                className={`dropdown ${
                  validationErrors.organizationName ? 'error' : ''
                }`}
                placeholder="Organization *"
                options={organizationList}
                value={userinfo.organizationName}
                onChange={selectedOption =>
                  setUserInfo({
                    ...userinfo,
                    organizationName: selectedOption
                  })
                }
                isDisabled={!!organizationIdFromUrl}
              />
              {validationErrors.organizationName && (
                <span className="error-message">
                  {validationErrors.organizationName}
                </span>
              )}
            </div>
            <div key="city">
              <input
                className={`inputStyles ${
                  validationErrors.city ? 'error' : ''
                }`}
                placeholder={handlePlaceHolder(initialDetails[2])}
                name={initialDetails[2].key}
                value={userinfo.city}
                onChange={e =>
                  setUserInfo({ ...userinfo, city: e.target.value })
                }
              />
              {validationErrors.city && (
                <span className="error-message">{validationErrors.city}</span>
              )}
            </div>
            <Button
              theme={theme}
              content="Submit"
              className="button-block"
              onClick={handleSubmit}
            />
            <div className="terms-and-conditions">
              <TermsAndConditions />
            </div>
          </div>
        </div>
      ) : (
        <div className="onboarding-form__salutation">
          <div>Congratulation !</div>
          <div className="onboarding-form__title">
            Welcome to Kings Club. Download app to avail exclusive Dine-in
            offers.
            <div
              className="onboarding-form__contents"
              onClick={downloadClicked}
            >
              Download App
            </div>
          </div>
        </div>
      )}
      {validationErrors.showErrorModal && (
        <LocationRestriction
          title={'Sorry'}
          description={validationErrors.errorMessage}
          okayClick={() =>
            setValidationErrors({ ...validationErrors, showErrorModal: false })
          }
        />
      )}
      {validationErrors123.showErrorModal && (
        <LocationRestriction
          title={'Sorry'}
          description={validationErrors123.errorMessage}
          okayClick={() => {
            setValidationErrors123({
              ...validationErrors123,
              showErrorModal: false
            });
            history.push('/');
          }}
        />
      )}
    </Modal>
  );
};

export default OfferOnboarding;
